// extracted by mini-css-extract-plugin
export default {"checkCell":"DataCollectorsTable_checkCell__EuRXD"};